// npm

// css
import '../../scss/pages/page-requirement.scss';

// libs

// utils
import RecruitFoundation from '../_utils/RecruitFoundation';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	const tabs = document.querySelectorAll('.js-tab');
	const contents = document.querySelectorAll('.js-recruting');

	// 初期状態で最初のタブとコンテンツを表示
	tabs[0].classList.add('active-tab');
	contents[0].classList.add('active-content');

	// 通常のタブ切り替え（ハッシュを変更しない）
	tabs.forEach((tab, index) => {
		tab.addEventListener('click', () => {
			showContent(index);
		});
	});

	// ハッシュからタブを表示する
	function showContentByHash() {
		const hash = window.location.hash.slice(1);
		const activeIndex = Array.from(contents).findIndex(
			(content) => content.id === hash
		);

		// ハッシュが有効な場合のみ対応するタブを表示
		if (activeIndex >= 0) {
			showContent(activeIndex);
		}
	}

	// 指定されたインデックスのタブとコンテンツを表示
	function showContent(activeIndex) {
		contents.forEach((content, index) => {
			content.classList.toggle('active-content', index === activeIndex);
		});
		tabs.forEach((tab, index) => {
			tab.classList.toggle('active-tab', index === activeIndex);
		});
	}

	// ページ読み込み時とハッシュが変更されたときにアンカーリンク対応の関数を実行
	showContentByHash();
	window.addEventListener('hashchange', showContentByHash);
});

window.addEventListener('load', () => {});
